import React, { FC } from 'react';
import { EFilterType, IFilterComponentProps } from './filter.types';
import useRawMaterials from 'FeatureModules/ComponentChain/hooks/useRawMaterials';
import { Skeleton } from '@mui/material';
import FilterAutocompleteSelection from 'Components/Filter/FilterAutocompleteSelection';

const RawMaterialFilter: FC<IFilterComponentProps<EFilterType.RAW_MATERIALS>> = ({
  value,
  label = 'Commodities',
  placeholder = 'All commodities',
  multiple,
  onChange,
}) => {
  const { rawMaterials, loading, createRawMaterial, error } = useRawMaterials();

  const handleAddNewItemClick = (title: string) => {
    createRawMaterial({ variables: { title } });
  };

  const handleSelectionChange = (selectedItems?: string | string[]) => {
    if (multiple && !Array.isArray(selectedItems)) {
      const newSelection = selectedItems as string[] | undefined;
      const updatedSelection = newSelection?.map(item => item) || [];
      onChange(updatedSelection);
    } else {
      onChange(selectedItems as string | undefined);
    }
  };

  const defaultValue = multiple ? [] : '';

  return (
    <>
      {loading ? (
        <Skeleton variant="rounded" width="100%" height={30} />
      ) : (
        <FilterAutocompleteSelection
          label={label}
          placeholder={placeholder}
          closeAfterSelection
          enableAddNewItem={false}
          multiple={multiple}
          itemName="raw material"
          items={rawMaterials}
          errorMessage={error?.message}
          hasError={!!error}
          selected={value || defaultValue}
          onAddNewItemClick={handleAddNewItemClick}
          onSelectionChange={handleSelectionChange}
        />
      )}
    </>
  );
};

export default RawMaterialFilter;
